import { Link as RouterLink } from 'react-router-dom';
import {
    BooleanField,
    Datagrid,
    DateField,
    List,
    TextField,
    TopToolbar,
} from 'react-admin';
import { Button } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

// Help knowledge CRUD lives inside /settings/* (not a react-admin Resource route),
// so every link targets an explicit /settings/help-knowledge/... path.
const ListActions = () => (
    <TopToolbar>
        <Button
            component={RouterLink}
            to="/settings/help-knowledge/create"
            startIcon={<AddIcon />}
            size="small"
        >
            Create
        </Button>
    </TopToolbar>
);

export const HelpDocumentList = () => (
    <List
        resource="help_documents"
        empty={false}
        sort={{ field: 'id', order: 'DESC' }}
        perPage={25}
        actions={<ListActions />}
        title="Help knowledge"
    >
        <Datagrid
            rowClick={id => `/settings/help-knowledge/${id}`}
            bulkActionButtons={false}
        >
            <TextField source="id" />
            <TextField source="title" />
            <TextField source="kind" />
            <BooleanField source="is_active" />
            <DateField source="created_at" showTime />
        </Datagrid>
    </List>
);
